import { ROUTE_NAME } from '@/lib/constant';
import { RouteConfig } from 'vue-router';

export default [
    {
        path: '/lucky/home/:activityId',
        name: ROUTE_NAME.LUCKY_HOME,
        meta: {
            title: '抽奖',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "lucky" */ '@/pages/lucky/index.vue'),
        }),
    },
] as RouteConfig[];
